module.exports = __webpack_public_path__ + "img/wx.74fb5c47.png";